export const baseTypeOptions = [
	{
		value: 'month',
		name: 'měsíční',
	},
	{
		value: 'day',
		name: 'denní',
	},
];

export const childrenOptions = [
	{
		value: '1',
		name: 'jedno',
	},
	{
		value: '2',
		name: '2 a více',
	},
];
